import {connect} from 'react-redux';
import {revokeFirebaseToken} from "../../thunks/Notifications";
import {setEnableMobileMenuSmall} from '../../actions/ThemeOptions';
import {logoutRequestStart} from '../../actions/Auth';
import {startInitiallyLoadingShops} from "../../actions/Shops";
import {useTranslation} from "react-i18next";
import {useHistory, Redirect} from 'react-router-dom';
import {
  IonPage,
  IonContent,
  IonButton,
} from "@ionic/react";

const Report = ({
                  firebaseToken,
                  revokeFirebaseToken,
                  setEnableMobileMenuSmall,
                  logoutRequestStart,

                  startInitiallyLoadingShops,
                  shopsAreInitiallyLoaded,
                  activeShop,
                  propsRoute,
                  shops,
                }) => {
  const {t} = useTranslation();
  let history = useHistory();

  if (propsRoute?.history.action === 'POP') {
    startInitiallyLoadingShops();
  }


  const logout = () => {
    firebaseToken && revokeFirebaseToken(firebaseToken);
    setEnableMobileMenuSmall(false);
    logoutRequestStart();
    setTimeout(() => history.replace(`/auth/login`), 200);
  };

  return (shopsAreInitiallyLoaded && activeShop && shops?.length) ? <Redirect replace to='/chats'/> : <IonPage>
    <IonContent forceOverscroll={false} className="login-content">
      <div className="login-container">
        <div className="login-wrap">
          <div className="login-form-title">
            <div>{t('pages.report.title', "You don't have any active channels. Restart the application or wait for the status update of your channel to work.")}</div>
          </div>
          <div className="w-100 login-form-button">
            <IonButton type="button" expand="block" mode="ios" className="i-button" onClick={logout}>
              {t('menu.exit', "Exit")}
            </IonButton>
          </div>
        </div>
      </div>
    </IonContent>
  </IonPage>
}

const mapStateToProps = state => ({
  firebaseToken: state.Notifications.firebaseToken,
  shopsAreInitiallyLoaded: state.Shops.shopsAreInitiallyLoaded,
  activeShop: state.Shops.activeShop,
  shops: state.Shops.shops,
});

const mapDispatchToProps = dispatch => ({
  revokeFirebaseToken: (firebaseToken, callback) => dispatch(revokeFirebaseToken(firebaseToken, callback)),
  setEnableMobileMenuSmall: (enabled) => dispatch(setEnableMobileMenuSmall(enabled)),
  logoutRequestStart: () => dispatch(logoutRequestStart()),
  startInitiallyLoadingShops: () => dispatch(startInitiallyLoadingShops()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
